const SunCheck = ({ width = 32, height = 32, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 33 32"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M18.2547 3.72202L20.4248 5.51081C20.8084 5.82699 21.2778 6.02133 21.7722 6.069L24.5716 6.33836C25.7602 6.45287 26.7008 7.39352 26.8153 8.5821L27.085 11.3815C27.1326 11.8762 27.327 12.3455 27.6432 12.7289L29.4319 14.899C30.1915 15.8205 30.1915 17.1506 29.4319 18.0721L27.6432 20.2422C27.327 20.6255 27.1326 21.0949 27.085 21.5896L26.8153 24.389C26.7008 25.5776 25.7602 26.5182 24.5716 26.6327L21.7722 26.9024C21.2775 26.95 20.8084 27.1444 20.4248 27.4603L18.2547 29.2493C17.3335 30.0086 16.0031 30.0086 15.0816 29.2493L12.9118 27.4603C12.5282 27.1444 12.0588 26.95 11.5641 26.9024L8.765 26.6327C7.57642 26.5182 6.63549 25.5776 6.52126 24.389L6.25161 21.5896C6.20394 21.0949 6.00961 20.6255 5.69343 20.2422L3.90464 18.0721C3.14507 17.1509 3.14507 15.8205 3.90464 14.899L5.69343 12.7291C6.00961 12.3455 6.20394 11.8762 6.25161 11.3815L6.52097 8.5821C6.63549 7.3938 7.57614 6.45287 8.76471 6.33864L11.5641 6.069C12.0588 6.02133 12.5282 5.82699 12.9115 5.51081L15.0816 3.72202C16.0031 2.96245 17.3335 2.96245 18.2547 3.72202Z"
        fill="#FFD782"
      />
      <path
        d="M24.928 16.4858C24.928 21.048 21.2297 24.7463 16.6675 24.7463C12.1055 24.7463 8.40723 21.048 8.40723 16.4858C8.40723 11.9239 12.1055 8.22559 16.6675 8.22559C21.2297 8.22559 24.928 11.9239 24.928 16.4858Z"
        fill="#FF8000"
      />
      <path
        d="M16.669 8.22559C15.9528 8.22559 15.2576 8.31669 14.5947 8.48818C18.1528 9.40824 20.781 12.64 20.781 16.4858C20.781 20.3316 18.1531 23.5634 14.5947 24.4835C15.2576 24.655 15.9528 24.7461 16.669 24.7461C21.2312 24.7461 24.9295 21.0478 24.9295 16.4858C24.9295 11.9236 21.2312 8.22559 16.669 8.22559Z"
        fill="#FF5F06"
      />
      <path
        d="M14.7461 20.6823C14.4378 20.6823 14.1422 20.5599 13.9242 20.3418L11.4568 17.8741C11.0027 17.4203 11.0027 16.6842 11.4568 16.2301C11.9106 15.7759 12.6468 15.7759 13.1009 16.2301L14.7464 17.8756L19.3106 13.3111C19.7647 12.8572 20.5009 12.8572 20.9547 13.3111C21.4088 13.7652 21.4088 14.5013 20.9547 14.9554L15.5683 20.3418C15.3503 20.5599 15.0547 20.6823 14.7461 20.6823Z"
        fill="#FEEBDD"
      />
    </svg>
  )
}

export default SunCheck
